export default (params) => ({
  trigger: {
    name: 'review_panel.select_image',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      title: {
        type: 'string',
      },
    },
    event: {
      name: 'select_visual',
      params: {
        visual_type: 'image',
        sub_feature: null,
      },
    },
  },
});
